// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  height: 70px;
  width: 100px;
}

.yusr-header {
  border-radius: 28px;
  border: 1px solid #36A3F7 !important;
  background: #FFF;
  padding: 10px;
}

.header-title {
  color: #575962;
  font-family: Cairo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px; /* 87.5% */
  margin-top: 20px;
  margin-bottom: 20px;
}

.header-text {
  color: #575962;
  font-family: Cairo;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 161.111% */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/branch-header/branch-header.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;AACJ;;AAEA;EACI,cAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,UAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,cAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AADJ","sourcesContent":[".logo {\n    height: 70px;\n    width: 100px;\n}\n\n.yusr-header {\n    border-radius: 28px;\n    border: 1px solid #36A3F7 !important;\n    background: #FFF;\n    padding: 10px;\n}\n\n.header-title {\n    color: #575962;\n    // text-align: right;\n    font-family: Cairo;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 21px; /* 87.5% */\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.header-text {\n    color: #575962;\n    // text-align: right;\n    font-family: Cairo;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px; /* 161.111% */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
